import { config } from '@uhg-abyss/web/tools/config';
import sortBy from 'lodash/sortBy';
import { getFeature } from '@sde/widgets-core/src/redux/tools/features';
import sections from './sections.json';

export const getLagoonEnv = () => {
  const appEnv = config('APP_ENV');
  if (appEnv === 'local') {
    return 'dev';
  }
  // TODO : Remove after release environment is added to lagoon
  if (appEnv === 'release' || appEnv === 'pull') {
    return 'stage';
  }
  if (appEnv === 'migration') {
    return 'stage';
  }
  return appEnv;
};

export const mapUpdates = (updates, position) => {
  const filteredUpdates = updates.filter((update) =>
    update.dataTestId.includes(position)
  );

  return filteredUpdates;
};

export const mapHeaderContents = (contents, menu, dropdown) => {
  const filteredByMenu = menu
    ? contents.filter((content) => {
        return content.menu === menu;
      })
    : contents;
  const filteredByDropdown = dropdown
    ? filteredByMenu.filter((content) => {
        return content.dropdown === dropdown;
      })
    : filteredByMenu.filter((content) => {
        return !content.dropdown;
      });
  const filteredAndSorted = sortBy(filteredByDropdown, 'order');
  return filteredAndSorted;
};

export const mapHeaderContentsForSearch = (applications) => {
  const search = applications.filter(
    (app) => app.type === 'link' || app.type === 'exitLink'
  );
  const sortedData = sortBy(search, (result) => result.name);
  return sortedData;
};

export const mapAdditionalToolsContents = (contents) => {
  const returnContent = [];
  const toolSections = sections['Additional Tools'];
  for (let i = 0; i < toolSections.length; i++) {
    if (getFeature(toolSections[i].status)) {
      returnContent.push({
        ...toolSections[i],
        contents: sortBy(
          contents.filter((app) => app.location === toolSections[i].section),
          'name'
        ),
      });
    }
  }
  return returnContent;
};

export const mapAdditionaToolsForSearch = (arrayOfContents) => {
  const sortedData = sortBy(arrayOfContents, (result) => result.name);
  const dataWithDashboardContentsFormat = sortedData.map((v) => ({
    ...v,
    dashboardContentsFormat: true,
  }));
  return dataWithDashboardContentsFormat;
};
